import React from 'react';
import EmployeeInfo from '../../components/employeemng/EmployeeInfo';

const EmployeeInfoContainer = ({ employee }) => {
  return <EmployeeInfo employee={employee} />;
};

export default EmployeeInfoContainer;
